/* ==========================================================================
   Naar Halı — mobilde küçülen header (05 Eki 2026)

   Sorun: 1024 px altında header iki satır (logo + arama) ve hep yapışık;
   812 px'lik ekranın 141 px'ini, yani %17'sini sürekli kapatıyordu.

   Çözüm: aşağı kaydırırken arama satırı gizlenir, yukarı kaydırınca geri gelir.
   Satır `display: none` ile DEĞİL, yapışkan bölümün alt kısmı `clip-path` ile
   kırpılarak gizleniyor (kural assets/naar-duzeltmeler.css içinde). Böylece
   sayfanın yüksekliği değişmiyor; iOS Safari'de içerik zıplamıyor ve kaydırma
   yönü kendi kendini tetikleyip titreme yapmıyor.

   Arama kutusu odaktayken ya da menü çekmecesi açıkken header küçülmez.
   Masaüstünde (>=1024 px) hiçbir şey yapmaz; orada temanın kendi davranışı var.
   ========================================================================== */
(function () {
  var arama = document.querySelector('.header__search');
  if (!arama) return;
  var bolum = arama.closest('.shopify-section');
  if (!bolum) return;

  var dar = window.matchMedia('(max-width: 1023.98px)');
  var sinif = 'naar-header-kucuk';
  var sonY = window.scrollY;
  var bekliyor = false;

  function olc() {
    if (!dar.matches) return;
    // Ölçüm açık haldeyken yapılmalı; küçükken sınıfı geçici kaldırmaya gerek yok,
    // clip-path yerleşimi değiştirmediği için kutular aynı kalıyor.
    var a = arama.getBoundingClientRect();
    var b = bolum.getBoundingClientRect();
    var pay = Math.max(0, Math.round(b.bottom - a.top + 6));
    // Kökte duruyor: header'ın altına yapışan öğeler de (koleksiyondaki filtre
    // çubuğu gibi) aynı pay kadar yukarı çıkabilsin.
    if (pay > 0) document.documentElement.style.setProperty('--naar-arama-payi', pay + 'px');
  }

  function mesgul() {
    var odak = document.activeElement;
    if (odak && arama.contains(odak)) return true;
    return document.body.classList.contains('predictive-search-open') || !!document.querySelector('.menu-drawer[open], details[open] > .menu-drawer');
  }

  function guncelle() {
    bekliyor = false;
    var y = window.scrollY;
    if (!dar.matches) {
      document.body.classList.remove(sinif);
      sonY = y;
      return;
    }
    if (y < 140 || y < sonY - 6) {
      document.body.classList.remove(sinif);
    } else if (y > 220 && y > sonY + 6 && !mesgul()) {
      document.body.classList.add(sinif);
    }
    sonY = y;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (bekliyor) return;
      bekliyor = true;
      window.requestAnimationFrame(guncelle);
    },
    { passive: true }
  );
  window.addEventListener('resize', olc, { passive: true });
  arama.addEventListener('focusin', function () {
    document.body.classList.remove(sinif);
  });
  // Küçükken header'a dokunulursa (menü, hesap, sepet) önce tam haline döner;
  // yoksa açılan çekmece kırpma alanının altında kalırdı.
  bolum.addEventListener(
    'pointerdown',
    function () {
      document.body.classList.remove(sinif);
    },
    true
  );

  if (document.readyState === 'complete') olc();
  else window.addEventListener('load', olc);
  olc();
})();
